import {
    BibliothequePage,
    CauseriesListPage,
    CauseriesPage,
    CauseriesTalkEmargementPage,
    CauseriesTalkFilesPage,
    CauseriesTalkListPage,
    CauseriesTalkQuestionsPage,
    CauseriesTalkResultsPage,
    EpiPage,
    EpiCategoryPage,
    EpiCartPage,
    EpiOrderCartPage,
    EpiFavoriteOrdersPage,
    EpiOrdersPage,
    EventFeedbackPage,
    EPIPage,
    GoldenRulesPage,
    HomeSecurityEmargement,
    MenuSanteSecuritePage,
    PPSPSPage,
    SecurityAuditPage,
    ToolsPage,
    WorksitePresentationPage,
    FormationPage,
    FormationListPage,
    FormationTalkListPage,
    FormationTalkFilesPage,
    FormationTalkQuestionsPage,
    FormationTalkResultsPage,
    FormationTalkEmargementPage,
    WithdrawalPage,
    MinorInfosPage,
    HomeSecurityMenuPage,
    WorksiteSelectionPage
} from '@pages';
import { FormationModulePage } from '@pages/SanteSecurite/FormationPage/FormationPage';
import { Navigate, RouteObject } from 'react-router-dom';

export const santeSecuriteRoutes = (isLogged: boolean | null | undefined): RouteObject[] => [
    {
        path: '/sante-securite',
        element: isLogged ? <MenuSanteSecuritePage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/bibliotheque',
        element: isLogged ? <BibliothequePage type="sst" /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/causeries',
        element: isLogged ? <CauseriesPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/causeries/list',
        element: isLogged ? <CauseriesListPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/causeries/list/:thematicId',
        element: isLogged ? <CauseriesTalkListPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/causeries/list/:thematicId/files/:talkId',
        element: isLogged ? <CauseriesTalkFilesPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/causeries/list/:thematicId/questions/:talkId',
        element: isLogged ? <CauseriesTalkQuestionsPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/causeries/list/:thematicId/results/:talkId',
        element: isLogged ? <CauseriesTalkResultsPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/causeries/list/:thematicId/emargement/:talkId',
        element: isLogged ? <CauseriesTalkEmargementPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/event-feedback',
        element: isLogged ? <EventFeedbackPage eventDestination="sst" /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/epi',
        element: isLogged ? <EpiPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/epi/category/:id',
        element: isLogged ? <EpiCategoryPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/epi/cart',
        element: isLogged ? <EpiCartPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/epi/orders',
        element: isLogged ? <EpiOrdersPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/epi/cart/:id',
        element: isLogged ? <EpiOrderCartPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/epi/orders/favorites',
        element: isLogged ? <EpiFavoriteOrdersPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/home-security',
        element: isLogged ? <WorksiteSelectionPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/home-security/emargement',
        element: isLogged ? <HomeSecurityEmargement /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/security-audit',
        element: isLogged ? <SecurityAuditPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/golden-rules',
        element: isLogged ? <GoldenRulesPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/home-security/tools',
        element: isLogged ? <ToolsPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/home-security/epis',
        element: isLogged ? <EPIPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/home-security/worksite-presentation',
        element: isLogged ? <WorksitePresentationPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/home-security/formation',
        element: isLogged ? <FormationPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/home-security/withdrawal',
        element: isLogged ? <WithdrawalPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/home-security/minor-infos',
        element: isLogged ? <MinorInfosPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/home-security/menu',
        element: isLogged ? <HomeSecurityMenuPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/formations',
        element: isLogged ? <FormationModulePage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/formations/list',
        element: isLogged ? <FormationListPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/formations/list/:categoryId',
        element: isLogged ? <FormationTalkListPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/formations/list/:categoryId/files/:formationId',
        element: isLogged ? <FormationTalkFilesPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/formations/list/:categoryId/questions/:formationId',
        element: isLogged ? <FormationTalkQuestionsPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/formations/list/:categoryId/results/:formationId',
        element: isLogged ? <FormationTalkResultsPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/formations/list/:categoryId/emargement/:formationId',
        element: isLogged ? <FormationTalkEmargementPage /> : <Navigate to="/login" replace />
    },
    {
        path: '/sante-securite/ppsps',
        element: isLogged ? <PPSPSPage /> : <Navigate to="/login" replace />
    }
];
